import React from 'react';
import {Row, Col, Alert, Card, CardBody, Container, Button} from 'reactstrap';
import {connect} from 'react-redux';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import queryString from 'query-string';
import logoImg from '../../assets/images/logo-brother.svg';
import {userResetPassword} from '../../store/actions';

const ResetPasswordPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = queryString.parse(location.search);

  const {register, handleSubmit, watch, formState: {errors}} = useForm();

  const password = watch('password');

  const onSubmit = (data) => {
    props.userResetPassword({...data, token: params.token}, navigate);
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <Card className="overflow-hidden">
              <div className="bg-dark mb-4 p-4">
                <Row>
                  <Col className="col-7">
                    <div className="px-4">
                      <h3 className="text-yellow mb-0">Brother TECNET</h3>
                      <p className="text-white">
                        {process.env.REACT_APP_REALM.toUpperCase() + ' '}
                        Dealer Service Platform
                      </p>
                    </div>
                  </Col>
                  <Col className="col-5 align-self-center text-right">
                    <div className="px-4">
                      <img src={logoImg} alt="" className="img-fluid"/>
                    </div>
                  </Col>
                </Row>
              </div>
              <CardBody>
                <div className="p-2">
                  {props.resetError && (
                    <Alert color="danger" style={{marginTop: '13px'}}>
                      {props.resetError}
                    </Alert>
                  )}
                  {props.resetSuccessMsg && (
                    <Alert color="success" style={{marginTop: '13px'}}>
                      {props.resetSuccessMsg}
                    </Alert>
                  )}

                  <form className="form-horizontal mt-4" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md="6">
                        <div className="form-group">
                          <label>Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Enter Password"
                            {...register('password', {
                              required: 'Please enter a password',
                              minLength: {value: 6, message: 'Password must be at least 6 characters'},
                              maxLength: {value: 16, message: 'Password must be at most 16 characters'},
                            })}
                          />
                          {errors.password && (
                            <p className="text-danger">{errors.password.message}</p>
                          )}
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="form-group">
                          <label>Confirm Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm Password"
                            {...register('password_confirmation', {
                              required: 'Please confirm your password',
                              validate: (value) => value === password || 'Passwords do not match',
                            })}
                          />
                          {errors.password_confirmation && (
                            <p className="text-danger">{errors.password_confirmation.message}</p>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row className="form-group">
                      <Col className="text-right">
                        <Button
                          className="btn btn-dark btn-block waves-effect waves-light"
                          type="submit"
                          disabled={props.loading}
                        >
                          {props.loading && <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"/>}
                          Reset
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>
            <div className="mt-5 text-center font-size-13">
              <p>
                Already have an account?{' '}
                <Link to="/login" className="font-weight-bold text-yellow">
                  Login
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStatetoProps = (state) => {
  const {resetError, resetSuccessMsg, loading} = state.ResetPassword;
  return {resetError, resetSuccessMsg, loading};
};

export default connect(mapStatetoProps, {userResetPassword})(ResetPasswordPage);
